import { AccordionCard } from "../../../../accordion/Accordion";
import KursusUndervisere from "./KursusUndervisere";
import { ApolloQueryResult, OperationVariables } from "@apollo/client";
import Kursusoplysninger from "./Kursusoplysninger";
import { useNavigate } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../../../ErrorFallback";
import { Kursushold } from "../../../../../interfaces/schema";
import KursusPrismatrix from "./KursusPrismatrix";
import { useState } from "react";

export default function KursusStamoplysninger(props: {
  kursushold: Kursushold;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      kursushold: Kursushold;
    }>
  >;
}) {
  const { kursushold, refetch } = props;
  const [editMode, setEditMode] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="container">
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => navigate("/kursus")}
      >
        <Kursusoplysninger
          editMode={editMode}
          setEditMode={setEditMode}
          kursushold={kursushold}
          invalidateData={refetch}
        />
        <AccordionCard
          title="Undervisere"
          value="undervisere"
          isEmpty={!kursushold.kursusholdUnderviser.length}
          localstorageKey="kursus-id-stamoplysninger-accordion-value"
        >
          <KursusUndervisere kursushold={kursushold} invalidateData={refetch} />
        </AccordionCard>
        <AccordionCard
          title={
            kursushold.kursustype === 3 ? "Prismatrix" : "Prismatrix (kun FMU)"
          }
          value="prismatrix"
          localstorageKey="kursus-pris-matrix"
          isEmpty={kursushold.kursustype !== 3}
          isDisabled={kursushold.kursustype !== 3}
        >
          {kursushold.kursustype === 3 && (
            <KursusPrismatrix kursushold={kursushold} />
          )}
        </AccordionCard>
      </ErrorBoundary>
    </div>
  );
}
